define('plugin/pwa/model/PwaDeviceModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * PWA device Model
     *
     * @class PwaDeviceModel
     */
    return BaseModel.extend({

        url: '/ext/pwa/device/',

        defaults: {
            'datetime': null,
            'hash': null,
            'token': null,
            'type': null
        },

        initialize: function () {
            this.url = this.url + '?' + jQuery.param({deviceToken: this._getDeviceToken()});

            this.on('sync', this._onModelSync);

            BaseModel.prototype.initialize.call(this);
        },

        _saveToken: function (token) {
            try {
                $.cookie("device_token", token, {
                    expires: 365,
                    path: '/'
                });
                if ("localStorage" in window) {
                    window.localStorage.setItem("device_token", token);
                }
            } catch (e) {
                console.warn('Impossible save device_token')
            }

            return token;
        },

        _getDeviceToken: function () {
            try {
                if ($.cookie('device_token') && this._validateToken($.cookie('device_token'))) {
                    return $.cookie('device_token');
                } else if ("localStorage" in window && this._validateToken(window.localStorage.getItem("device_token"))) {
                    return window.localStorage.getItem("device_token");
                }
            } catch (e) {
                console.warn('Impossible get device_token. Generated new device_token')
            }

            var token = this._generateToken();
            this._saveToken(token);

            return token;
        },

        _validateToken: function (token) {
            if (!token) {
                return false;
            }
            if (String(token).length < 8) {
                return false;
            }
            return true;
        },

        _generateToken: function () {
            var token = Math.random().toString(36).substr(2);
            token += Math.random().toString(36).substr(2);
            return token;
        },

        _onModelSync: function () {
            var token = this.get('token');

            if (token !== this._getDeviceToken()) {
                this._saveToken(token);
            }
        }
    });

});
